"use strict";

window.PXUTheme.contentCreator.accordion = {
  init: function () {
    const $accordionHeading = $('.accordion > dt > a, [data-cc-accordion] > dt > a');
    $('.accordion > dd, [data-cc-accordion] > dd').attr('aria-hidden', true);
    $accordionHeading.attr('aria-expanded', false);
    $accordionHeading.on('click', function () {
      let state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $accordionHeading.on('keydown', function (event) {
      let keyCode = event.keyCode || e.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  },
  unload: function () {
    $('.accordion > dt > a, [data-cc-accordion] > dt > a').off('click activate');
    $('.accordion > dt > a, [data-cc-accordion] > dt > a').off('keydown');
  }
};
window.PXUTheme.contentCreator.slideshow = {
  init: function () {
    //backwards compatibility with flexslider
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
      pageDots: true,
      lazyLoad: 2
    });
  }
};
window.PXUTheme.animation = {
  init: function () {
    $('[data-scroll-class]').waypoint(function () {
      const animationClass = $(this.element).data('scroll-class');
      $(this.element).addClass('animated').addClass(animationClass);
    }, {
      offset: '70%'
    });
  },
  slideTransition: function ($el, animationName, callback) {
    $el.parents('.flickity-enabled').find('.animated').removeClass('animated ' + animationName);
    $el.addClass('animated').addClass(animationName);
  },
  unload: function ($target) {
    $target.data('scroll-class', '');
  }
};
const deferred = {};
window.PXUTheme.asyncView = {
  /**
   * Load the template given by the provided URL into the provided
   * view
   *
   * @param {string} url - The url to load.
   * @param {string} view - The view to load into.
   * @param {object} options - Config options.
   * @param {string} options.hash - A hash of the current page content.
   */
  load: function (url, view) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let data;
    if (url in deferred) {
      return deferred[url];
    }
    const $deferred = $.Deferred();
    deferred[url] = $deferred;
    if (options.hash) {
      data = sessionStorage.getItem(url);
      if (data) {
        const deserialized = JSON.parse(data);
        if (options.hash === deserialized.options.hash) {
          delete deferred[url];
          return $deferred.resolve(deserialized).promise();
        }
      }
    }

    // NOTE The $.ajax request has the cache option set to false.
    // This is to prevent certain browsers from returning cached
    // versions of the url we are requesting.
    // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
    $.ajax({
      url,
      cache: false,
      data: `view=${view}`,
      dataType: 'html',
      headers: {
        'cache-control': 'no-cache'
      },
      success: response => {
        let responseOptions;
        let html = {};
        try {
          const el = document.createElement('div');
          el.innerHTML = response;
          const optionsElement = el.querySelector('[data-options]');
          const htmls = el.querySelectorAll('[data-html]');
          if (!optionsElement || htmls.length === 0) {
            throw new Error('The cart view response is incomplete.');
          }
          responseOptions = JSON.parse(optionsElement.innerHTML);
          if (!responseOptions || typeof responseOptions !== 'object' || Array.isArray(responseOptions)) {
            throw new Error('The cart view options are invalid.');
          }
          if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
            html = htmls[0].innerHTML;
          } else {
            for (let i = 0; i < htmls.length; i++) {
              html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
            }
          }
        } catch (error) {
          // A malformed HTTP 200 must settle and clear the cached request so
          // callers can report the refresh failure and retry normally.
          delete deferred[url];
          return $deferred.reject(error);
        }
        if (options.hash) {
          try {
            sessionStorage.setItem(url, JSON.stringify({
              options: responseOptions,
              html
            }));
          } catch (error) {
            console.error(error);
          }
        }
        delete deferred[url];
        return $deferred.resolve({
          options: responseOptions,
          html
        });
      },
      error: () => {
        delete deferred[url];
        return $deferred.reject();
      }
    });
    return $deferred.promise();
  }
};
window.PXUTheme.addImageDimension = function (imageUrl, size) {
  var insertPosition = imageUrl.lastIndexOf(".");
  return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
};
window.PXUTheme.breadcrumbs = {
  init: function (pages) {
    // Show pagination if number of pages is greater than 1
    if (pages > 1) {
      const breadcrumbSpan = document.querySelector('[data-breadcrumb-text]');
      const currentPage = document.querySelector('.paginate').dataset.currentPage ? document.querySelector('.paginate').dataset.currentPage : 1;
      const totalPages = document.querySelector('.paginate').dataset.paginatePages;
      document.querySelector('.js-breadcrumb-text').classList.remove('is-hidden');
      breadcrumbSpan.innerHTML = `${window.PXUTheme.translation.page_text} ${currentPage} ${window.PXUTheme.translation.of_text} ${totalPages}`;
    }
  },
  unload: function ($target) {
    document.querySelector('.js-breadcrumb-text').classList.add('is-hidden');
  }
};
window.PXUTheme.debounce = function (func, wait, immediate) {
  let timeout = null;
  return () => {
    const context = this;
    const args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};
window.PXUTheme.disclosure = {
  enable: function () {
    const $disclosure = $('[data-disclosure]');
    const $toggle = $('[data-disclosure-toggle]');
    const $disclosureWrap = $('.disclosure__list-wrap');
    const $mobileMenuDisclosureList = $('[data-disclosure-list]');

    // Check if current opened menu is offscreen
    function checkOffScreen($openedToggle) {
      if ($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }
    function closeDisclosures(ignoreTarget, currentTarget) {
      if (ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }
      $disclosureWrap.removeClass('disclosure--left');
    }

    // Close menus on ESC
    $('body').on('keyup', function (e) {
      if (e.which == '27') {
        closeDisclosures();
      }
    });

    // Close menus on hoverout
    $disclosure.on('mouseleave', function (e) {
      closeDisclosures();
    });

    // Close menus on hoverout
    $disclosure.find('.disclosure-list__item:last-child').on('focusout', function (e) {
      closeDisclosures();
    });

    // On click/focus event for toggling options
    $toggle.on('mouseenter focus', function (e) {
      // Close all other menus
      closeDisclosures(true, this);
      const $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    });

    // Mobile toggle logic
    $mobileMenuDisclosureList.on('touchstart', function (e) {
      const $target = $(e.currentTarget);
      $target.parents('.disclosure').addClass('is-clicked');
      closeDisclosures(true, this);
      if ($target.hasClass('is-clicked') == false) {
        $target.attr('aria-expanded', 'true').addClass('is-clicked');
        checkOffScreen($target);
      } else {
        $target.attr('aria-expanded', 'false').removeClass('is-clicked');
        $disclosureWrap.removeClass('disclosure--left');
      }
    });
    $mobileMenuDisclosureList.on('focusout', function (e) {
      closeDisclosures(true, this);
    });

    // Mobile form submitting
    $mobileMenuDisclosureList.on('change', function (e) {
      if (window.PXUTheme.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const $target = $(e.currentTarget);
        const selectedValue = e.currentTarget.value;
        const disclosureInput = $target.parents('.selectors-form__item').find('[data-disclosure-input]');
        const selectorForm = $target.parents('.selectors-form');
        if (!$target.hasClass('custom-currency')) {
          disclosureInput.val(selectedValue);
          selectorForm.submit();
        } else {
          $target.trigger('click');
        }
      }
    });
  },
  unload: function () {
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
    $('.disclosure__list-wrap').off();
  }
};
window.PXUTheme.dropdownMenu = function () {
  // Grab menu items
  const menuItems = $('.navbar-link');

  // Grab dropdowns
  const dropdowns = $('.navbar-dropdown');

  // Grab megamenus

  const megamenus = $('.has-mega-menu');

  const standardDropdowns = $('.esl-navigation-header .navbar-item.has-dropdown:not(.has-mega-menu)');
  standardDropdowns.each(function () {
    const $item = $(this);
    const $trigger = $item.children('label').children('.header__link').first();
    $item.off('.eslStandardDropdown')
      .on('keydown.eslStandardDropdown', function (event) {
        if (event.key === 'Escape' || event.which === 27) {
          event.preventDefault();
          event.stopPropagation();
          $trigger.trigger('focus');
          $item.addClass('esl-dropdown-dismissed').removeClass('show-dropdown');
          $item.find('.show-nested-dropdown').removeClass('show-nested-dropdown');
          $trigger.attr('aria-expanded', 'false');
        } else if (event.target === $trigger[0] && $item.hasClass('esl-dropdown-dismissed') &&
          (event.key === 'Enter' || event.key === ' ' || event.which === 13 || event.which === 32)) {
          event.preventDefault();
          $item.removeClass('esl-dropdown-dismissed').addClass('show-dropdown');
          $trigger.attr('aria-expanded', 'true');
        }
      })
      .on('focusin.eslStandardDropdown', function (event) {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        $item.removeClass('esl-dropdown-dismissed');
        $trigger.attr('aria-expanded', 'true');
      })
      .on('focusout.eslStandardDropdown', function (event) {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        $item.removeClass('esl-dropdown-dismissed');
        $trigger.attr('aria-expanded', 'false');
      })
      .on('mouseenter.eslStandardDropdown', function () {
        $item.removeClass('esl-dropdown-dismissed');
        $trigger.attr('aria-expanded', 'true');
      })
      .on('mouseleave.eslStandardDropdown', function () {
        if (!this.contains(document.activeElement) && !$item.hasClass('show-dropdown')) {
          $trigger.attr('aria-expanded', 'false');
        }
      });
  });

  // Listen for enter key
  menuItems.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }

        // Show dropdown
        $(this).closest('.navbar-item').addClass('show-dropdown');

        // Reset itemVisited so that they can visit the link
        itemVisited = true;
      }
    });
    $(item).closest('.navbar-item').on('focusout', function (e) {
      if ($(this).find(e.relatedTarget).length === 0) {
        $(item).closest('.navbar-item').removeClass('show-dropdown');
      }
    });
  });

  // Listen for enter key
  dropdowns.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }
        if ($(this).find('.has-submenu').length > 0) {
          $(this).addClass('show-nested-dropdown');
        }

        // Reset itemVisited so that they can visit the link
        itemVisited = true;
      }
    });
  });

  // Listen for enter key
  megamenus.each(function (index, item) {
    let itemVisited = false;
    const $trigger = $(item).children('label').children('.header__link').first();
    $trigger.attr({
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    });

    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }

        // Show megamenu
        $(this).find('.mega-menu').addClass('mega-menu--show');
        $trigger.attr('aria-expanded', 'true');

        // Reset itemVisited so that they can visit the link
        itemVisited = true;
      }
    });

    // Hide mega menu on focusout
    $(item).on('focusout', function (e) {
      if ($(item).find(e.relatedTarget).length === 0) {
        $(item).find('.mega-menu').removeClass('mega-menu--show');
        $trigger.attr('aria-expanded', 'false');
        itemVisited = false;
      }
    });
  });
};
window.PXUTheme.collapsibleRowUtil = {
  init: selector => {
    const headingSelector = selector || '.faq-accordion';
    const $faqHeading = $(`${headingSelector} > dt > button`);
    $(`${headingSelector} > dd`).attr('aria-hidden', true);
    $faqHeading.attr('aria-expanded', false);
    $faqHeading.off('click activate').on('click activate', e => {
      const $target = $(e.currentTarget);
      const $faqIcons = $target.find('.icon');
      const $plus = $target.find('.plus');
      const $state = $target.attr('aria-expanded') === 'false';
      $plus.toggleClass('collapsed');
      $target.attr('aria-expanded', $state);
      $target.parent().next().slideToggle(() => {
        $faqIcons.toggleClass('icon--active');
      });
      $target.parent().next().attr('aria-hidden', !$state);
      return false;
    });
  },
  unload: selector => {
    const headingSelector = selector || '.faq-accordion';
    $(`${headingSelector} > dt > button`).off('click activate');
    $(`${headingSelector} > dt > button`).off('keydown');
  }
};
window.PXUTheme.newsletterAjaxForm = {
  init: function () {
    // Selectors
    const $ajaxForm = $('.newsletter-form__wrapper .contact-form');
    $ajaxForm.each(function () {
      const $form = $(this);
      $form.on('submit', function (e) {
        if ($('input[name="challenge"]', $form).val() !== "true") {
          $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function (data) {
              $form.fadeOut("slow", () => {
                $form.prev('.form__success-message').html(window.PXUTheme.translation.newsletter_form_success);
              });
            },
            error: function (data) {
              $('input[name="challenge"]', $form).val('true');
              $form.submit();
            }
          });
          e.preventDefault();
        }
      });
    });
  },
  unload: function () {
    const $ajaxForm = $('.newsletter-form__wrapper .contact-form');
    const $submitButton = $ajaxForm.find(':submit');
    $submitButton.off();
  }
};
window.PXUTheme.getSectionData = function ($section) {
  const sectionId = $section.attr('id').replace('shopify-section-', '');
  const $dataEl = $section.find(`[data-section-data][data-section-id=${sectionId}]`).first();
  if (!$dataEl) return {};

  // Load data from attribute, or innerHTML
  const data = $dataEl.data('section-data') || $dataEl.html();
  try {
    return JSON.parse(data);
  } catch (error) {
    console.warn(`Sections: invalid section data found. ${error.message}`);
    return {};
  }
};
window.PXUTheme.infiniteScroll = {
  init() {
    this.defaults = {
      grid: '[data-load-more--grid]',
      gridItems: '[data-load-more--grid-item]'
    };
    $('body').off('click', '[data-load-more]');
    $('body').on('click', '[data-load-more]', function (e) {
      e.preventDefault();
      const $button = $(this);
      const url = $button.attr('href');
      window.PXUTheme.infiniteScroll.loadNextPage(url, $button);
    });
    $('body').off('click', '[data-load-more-infinite]');
    $('body').on('click', '[data-load-more-infinite]', function (e) {
      window.PXUTheme.infiniteScroll.enableInfinite();
      $(this).remove();

      // Prevent link from going to next page
      e.stopPropagation();
      return false;
    });
    if ($('[data-load-infinite-scroll]').length) {
      window.PXUTheme.infiniteScroll.enableInfinite();
    }
  },
  loadNextPage(url, $button) {
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url,
      beforeSend() {
        $button.addClass('is-loading');
      },
      success: data => {
        $button.removeClass('is-loading');
        const thumbnails = $(data).find(this.defaults.gridItems);
        const loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');
        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $(this.defaults.grid).first().append(thumbnails);

        // Initialize product reviews
        window.PXUTheme.productReviews.init();

        // When there are no additional pages, hide load more button
        if (typeof loadMoreButtonUrl === 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(`${location.protocol}//${location.host}`);
      }
    });
  },
  enableInfinite() {
    var infiniteScroll = new Waypoint.Infinite({
      element: $(this.defaults.grid)[0],
      items: '[data-load-more--grid-item]',
      more: '[data-load-infinite]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad() {
        $('[data-load-infinite]').removeClass('is-hidden');
      },
      onAfterPageLoad() {
        // Initialize product reviews
        window.PXUTheme.productReviews.init();
      }
    });
  },
  unload() {
    $('[data-load-more]').off();
    $('[data-load-infinite]').off();
    $('[data-load-more-infinite]').off();
  }
};
window.PXUTheme.flickityIosFix = function () {
  var touchingCarousel = false,
    touchStartCoords;
  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }
    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    };
  });
  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }
    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };
    if (Math.abs(moveVector.x) > 7) e.preventDefault();
  }, {
    passive: false
  });
};
window.PXUTheme.loadScript = function (name, url, callback) {
  if (window.PXUTheme[name]) {
    callback;
  } else {
    $.ajax({
      url,
      dataType: 'script',
      success: callback,
      async: false
    });
  }
};
window.PXUTheme.applyMasonry = function (selector, gutterSize) {
  let $galleryWrapper = $('.gallery__wrapper--vertical-masonry');
  if ($galleryWrapper.length > 0) {
    $galleryWrapper.imagesLoaded().progress(function () {
      $galleryWrapper.isotope({
        layoutMode: 'masonry',
        itemSelector: selector,
        percentPosition: true,
        masonry: {
          columnWidth: selector,
          gutter: gutterSize
        }
      });
    });
  }
};
window.PXUTheme.applyHorizontalMasonry = function () {
  let $galleryWrapper = $('.gallery__wrapper--horizontal-masonry');
  $galleryWrapper.find('.gallery__item').each(function (e) {
    var wrapper = $(this);
    var imgWidth, imgHeight;
    setTimeout(function () {
      imgWidth = wrapper.find('img').width();
      imgHeight = wrapper.find('img').height();
      wrapper.css("flex-basis", imgWidth * 200 / imgHeight);
      wrapper.css("flex-grow", imgWidth * 200 / imgHeight);
      wrapper.find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    }, 100);
  });
};
window.PXUTheme.mobileMenu = {
  init: function () {
    this.$mobileMenuToggle = $('[data-show-mobile-menu]');
    this.$mobileMenuIcon = $('.mobile-menu__toggle-icon');
    this.$mobileMenu = $('#mobile-menu-panel');
    const dialog = document.getElementById('esl-mobile-menu-dialog');
    if (!dialog) {
      this.close(false);
      return;
    }
    if (this.dialog !== dialog || !this.menuEvents) {
      this.unlockPageScroll();
      if (this.menuEvents) this.menuEvents.abort();
      this.dialog = dialog;
      this.menuEvents = new AbortController();
      const options = { signal: this.menuEvents.signal };
      this.$mobileMenuToggle.each((index, button) => {
        button.addEventListener('click', event => {
          event.preventDefault();
          this.open(button, event.detail !== 0);
        }, options);
      });
      dialog.addEventListener('close', () => {
        if (!dialog.open) this.finishClose();
      }, options);
      dialog.addEventListener('change', event => {
        if (event.target.matches('.submenu__input')) this.syncSubmenus();
      }, options);
      dialog.addEventListener('keydown', () => {
        dialog.classList.remove('esl-menu-pointer-open');
      }, options);
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.close(false);
      }, options);
      window.addEventListener('resize', () => this.scheduleViewport(), options);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', () => this.scheduleViewport(), options);
        window.visualViewport.addEventListener('scroll', () => this.scheduleViewport(), options);
      }
    }
    $('body').off('.mobileMenu');
    this.$mobileMenu.find('.has-no-submenu > .submenu__input').attr('tabindex', '-1');
    this.syncSubmenus();
    this.setOpenState(dialog.open);
    if (window.PXUTheme.jsHeader.enable_sticky === true && !$('#mobile-header').hasClass('sticky--enabled')) {
      this.enableSticky();
    }
  },
  setOpenState: function (open) {
    document.body.classList.toggle('esl-mobile-menu-dialog-open', open);
    document.body.classList.remove('mobile-menu--opened');
    this.$mobileMenuToggle.attr('data-show-mobile-menu', String(open)).attr('aria-expanded', String(open));
    this.$mobileMenuIcon.removeClass('is-active');
    this.$mobileMenu.removeAttr('inert').attr('aria-hidden', String(!open));
  },
  lockPageScroll: function () {
    if (this.pageScrollLock) return;
    const root = document.documentElement;
    const body = document.body;
    const x = window.scrollX;
    const y = Math.max(0, window.scrollY);
    const entries = [];
    const set = (element, property, value) => {
      entries.push({ element, property, value: element.style.getPropertyValue(property), priority: element.style.getPropertyPriority(property) });
      element.style.setProperty(property, value, 'important');
    };
    this.pageScrollLock = { x, y, entries };
    set(root, 'scroll-behavior', 'auto');
    set(root, 'overflow-x', 'hidden');
    set(root, 'overflow-y', 'hidden');
    set(root, 'overscroll-behavior-x', 'none');
    set(root, 'overscroll-behavior-y', 'none');
    set(body, 'position', 'fixed');
    set(body, 'top', `${-y}px`);
    set(body, 'left', `${-x}px`);
    set(body, 'width', '100%');
    set(body, 'overflow-x', 'hidden');
    set(body, 'overflow-y', 'hidden');
    set(body, 'overscroll-behavior-x', 'none');
    set(body, 'overscroll-behavior-y', 'none');
  },
  unlockPageScroll: function () {
    if (this.viewportFrame) window.cancelAnimationFrame(this.viewportFrame);
    this.viewportFrame = 0;
    if (this.dialog) {
      this.dialog.style.removeProperty('--esl-menu-viewport-height');
      this.dialog.style.removeProperty('--esl-menu-viewport-top');
    }
    const saved = this.pageScrollLock;
    if (!saved) return;
    this.pageScrollLock = null;
    const restore = entry => {
      if (entry.value) entry.element.style.setProperty(entry.property, entry.value, entry.priority);
      else entry.element.style.removeProperty(entry.property);
    };
    saved.entries.filter(entry => entry.property !== 'scroll-behavior').forEach(restore);
    window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
    saved.entries.filter(entry => entry.property === 'scroll-behavior').forEach(restore);
  },
  syncViewport: function () {
    if (!this.dialog || !this.dialog.open) return;
    const viewport = window.visualViewport;
    const height = viewport && viewport.height > 0 ? viewport.height : window.innerHeight;
    const top = viewport && viewport.height > 0 ? Math.max(0, viewport.offsetTop) : 0;
    if (height <= 0) return;
    this.dialog.style.setProperty('--esl-menu-viewport-height', `${height}px`);
    this.dialog.style.setProperty('--esl-menu-viewport-top', `${top}px`);
  },
  scheduleViewport: function () {
    if (!this.dialog || !this.dialog.open || this.viewportFrame) return;
    this.viewportFrame = window.requestAnimationFrame(() => {
      this.viewportFrame = 0;
      this.syncViewport();
    });
  },
  syncSubmenus: function () {
    this.$mobileMenu.find('.submenu__input').each(function () {
      const $submenu = $(this).siblings('.mobile-menu__submenu');
      $submenu.attr('aria-hidden', this.checked ? 'false' : 'true');
      if (this.checked) $submenu.removeAttr('inert');
      else $submenu.attr('inert', '');
    });
  },
  open: function (trigger, fromPointer) {
    if (!this.dialog || this.dialog.open) return;
    this.returnFocus = trigger || this.$mobileMenuToggle[0];
    this.restoreMenuFocus = true;
    const cart = window.PXUTheme.jsAjaxCart;
    if (cart) {
      cart.hideMiniCart();
      cart.hideDrawer();
    }
    this.syncSubmenus();
    this.$mobileMenu.removeAttr('inert').attr('aria-hidden', 'false');
    this.dialog.classList.toggle('esl-menu-pointer-open', Boolean(fromPointer));
    this.lockPageScroll();
    try {
      this.dialog.showModal();
      this.setOpenState(true);
      this.syncViewport();
    } catch (error) {
      this.finishClose();
      throw error;
    }
  },
  finishClose: function () {
    this.unlockPageScroll();
    if (this.dialog) this.dialog.classList.remove('esl-menu-pointer-open');
    this.setOpenState(false);
    if (this.restoreMenuFocus !== false && this.returnFocus && this.returnFocus.isConnected) {
      this.returnFocus.focus({ preventScroll: true });
    }
    this.returnFocus = null;
    this.restoreMenuFocus = true;
  },
  close: function (restoreFocus) {
    if (!this.dialog) return;
    this.restoreMenuFocus = restoreFocus !== false;
    if (this.dialog.open) this.dialog.close();
    this.finishClose();
  },
  enableSticky: function () {
    window.PXUTheme.jsHeader.disableSticky();
    let $stickyEl = $('#mobile-header');
    let offset = 0;
    if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
      offset = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
    }
    $stickyEl.addClass('sticky--enabled');
    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 40,
      topSpacing: offset
    }).off('.mobileMenu').on('sticky-start.mobileMenu', () => {
      var headerheight = $('#mobile-header').height();
      var annoucementHeight = $('.announcement-sticky-wrapper').height();
      var totalHeight = headerheight + annoucementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');
    }).on('sticky-end.mobileMenu', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');
      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);
      $stickyEl.find('.sticky-menu-wrapper').removeClass('is-visible');
    });
  },
  disableSticky: function () {
    let $stickyEl = $('#mobile-header');
    $stickyEl.off('.mobileMenu');
    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');
    setTimeout(function () {
      $('.header-sticky-wrapper').css('height', 'auto');
    }, 250);
  },
  unload: function () {
    this.close(false);
    if (this.menuEvents) this.menuEvents.abort();
    this.menuEvents = null;
    this.dialog = null;
    $('body').off('.mobileMenu');
    this.disableSticky();
  }
};
if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function formatMoney(cents, format) {
  function defaultTo(value, fallback) {
    return typeof value === 'undefined' ? fallback : value;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (Number.isNaN(Number(number)) || number == null) return 0;
    number = (number / 100).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const decimals = parts[1] ? decimal + parts[1] : '';
    return dollars + decimals;
  }
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || this.money_format;
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '.');
      break;
    default:
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

/*============================================================================
Product media controls
==============================================================================*/

window.PXUTheme.productMedia = {
  models: [],
  setupMedia: function () {
    const config = {
      // Default control list
      controls: ['zoom-in', 'zoom-out', 'fullscreen'],
      focusOnPlay: false
    };
    $('model-viewer').each(function (index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      window.PXUTheme.productMedia.models.push(model);
    });
    $('.product-gallery__model model-viewer').on('mousedown', function () {
      window.PXUTheme.productMedia.hideModelIcon(this);
    });
  },
  showModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
};
window.PXUTheme.productReviews = {
  init: function () {
    if ($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
      SPR.$(document).ready(function () {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      });
    }
  },
  productReviewScroll: function () {
    if ($('#shopify-product-reviews').length && $('.shopify-product-reviews-badge').length) {
      $('.spr-badge-container').on('click', function () {
        window.PXUTheme.scrollToTop('#shopify-product-reviews');
      });
    }
  },
  unload: function () {
    $('.spr-badge-container').off();
  }
};
window.PXUTheme.quantityBox = {
  init: function () {
    $('body').on('click', '[data-update-quantity]:not([disabled])', function () {
      window.PXUTheme.quantityBox.updateQuantity($(this));
    });
    $('body').on('keyup keydown change', '.quantity-input', function () {
      window.PXUTheme.quantityBox.updateQuantity($(this));
    });
  },
  updateQuantityControls: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    let val = parseInt($input.val());
    let valMax = 100000000000000000;
    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }
    if (val === 1 || val === 0) {
      $('.quantity-minus', $quantityBox).attr('disabled', true);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } else if (val >= valMax) {
      $('.quantity-plus', $quantityBox).attr('disabled', true);
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $input.val(valMax);
    } else {
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    }
  },
  updateQuantity: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    const lineID = $quantityBox.parents('[data-line-item]').data('line-item');
    let val = parseInt($input.val());
    let valMax = 100000000000000000;
    let valMin = $input.attr('min') || 0;
    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }
    if (val < valMin) {
      $input.val(valMin);
      return false;
    } else if (val > valMax) {
      $input.val(valMax);
      return false;
    }
    if ($el.data('update-quantity') === 'plus') {
      // Increase quantity input by one
      if (val < valMax) {
        val++;
        $input.val(val);
      }
    } else if ($el.data('update-quantity') === 'minus') {
      // Decrease quantity by one
      if (val > valMin) {
        val--;
        $input.val(val);
      }
    }

    // Update quantity if within cart (vs on the product page)
    if ($el.parents('[data-line-item]').length) {
      const lineID = $quantityBox.data('line-item-key');
      window.PXUTheme.quantityBox.updateCart(lineID, val);
    }

    // Call to update quantity controls
    window.PXUTheme.quantityBox.updateQuantityControls($el);
  },
  updateCart: function (lineID, quantity) {
    $('.quantity-warning').removeClass('animated bounceIn');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: `quantity=${quantity}&line=${lineID}`,
      dataType: 'json',
      success: function (cart) {
        let newQuantity = 0;
        let itemsLeftText = '';
        let quantityWarning = $(`[data-line-item="${lineID}"]`).find('.quantity-warning');
        let $quantityBox = $(`[data-line-item="${lineID}"]`).find('.product-quantity-box');
        let $currentDiscount = $('.cart__form').data('currentDiscount');

        //check to see if there are correct amount of products in array
        const cartItemsLineID = lineID - 1;
        if (typeof cart.items[cartItemsLineID] !== "undefined") {
          newQuantity = cart.items[cartItemsLineID].quantity;
        }
        for (let i = 0; i < cart.items.length; i++) {
          if (i != cartItemsLineID) {
            if (cart.items[i].id == cart.items[cartItemsLineID].id) {
              newQuantity += cart.items[i].quantity;
            }
          }
        }
        if (quantity > 0 && quantity != newQuantity) {
          //Check if total discount has changed
          if (cart.total_discount <= $currentDiscount) {
            if (newQuantity == 1) {
              itemsLeftText = window.PXUTheme.translation.product_count_one;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
              $('.quantity-minus', $quantityBox).attr('disabled', true);
            } else {
              itemsLeftText = window.PXUTheme.translation.product_count_other;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
            }
          }
        }

        //Update total discount value
        $('.cart__form').data('currentDiscount', cart.total_discount);

        // Apply quantity warning
        quantityWarning.addClass('animated bounceIn');
        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.updateView(cart, lineID);
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response;
        try {
          response = JSON.parse(XMLHttpRequest.responseText);
        } catch (parseError) {
          response = null;
        }
        response = response && response.description;
      }
    });
  },
  unload: function ($target) {
    $('.quantity-input').off();
    $('[data-update-quantity]').off();
  }
};
window.PXUTheme.queryParameters = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      window.PXUTheme.queryParameters[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
window.PXUTheme.responsiveVideo = {
  init: function () {
    // Find youtube iframes
    var $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');

    // For each iframe, if parent is a responsive video wrapper do nothing
    // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

    $videoIframes.each(function (index, iframe) {
      // Update selector
      var $iframe = $(iframe);
      if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
        $iframe.wrap('<div class="lazyframe" data-ratio="16:9"></div>');
      }
    });
  }
};
window.PXUTheme.productPreorder = {
  getState: function (variant, inventory, dates) {
    const emptyState = { enabled: false, notice: '', property: '' };
    if (!variant || !Array.isArray(dates) || !Array.isArray(inventory)) return emptyState;
    const item = inventory.find(entry => entry.id === variant.id);
    const arrival = dates.find(entry => entry.id === variant.id);
    if (!item || !item.inventory_management || !Number.isFinite(item.inventory_quantity) || item.inventory_quantity > 0 || !arrival || !arrival.date) return emptyState;
    const enabled = variant.available === true && item.inventory_policy === 'continue';
    return { enabled, notice: arrival.notice || '', property: enabled ? arrival.property || '' : '' };
  },
  update: function ($forms, variant) {
    $forms.filter('[data-preorder-variants]').each(function () {
      const $form = $(this);
      const preorder = window.PXUTheme.productPreorder.getState(variant, $form.data('variant-inventory'), $form.data('preorder-variants'));
      $form.attr('data-preorder-active', String(preorder.enabled));
      $form.attr('data-preorder-purchasable', String(Boolean(variant && variant.available)));
      $form.find('[data-preorder-notice]').text(preorder.notice).prop('hidden', !preorder.notice);
      $form.find('[data-preorder-property]').val(preorder.property).prop('disabled', !preorder.enabled);
      $form.find('[data-add-to-cart-trigger]').each(function () {
        const $button = $(this);
        const label = preorder.enabled ? $form.data('preorder-label') : $button.data('default-label');
        $button.data('label', label).attr('data-label', label);
      });
    });
  }
};
function selectCallback(productEl, product, variant, state) {
  const $product = $(productEl);
  const $notifyForm = $('.product__notify-form', $product);
  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');
  window.PXUTheme.productPreorder.update($productForm, variant);
  const $productFormInput = $productForm.find('.quantity-input');
  const $notifyFormInputs = $('.notify_form__inputs');
  const notifyEmail = window.PXUTheme.translation.notify_form_email;
  const notifyEmailValue = window.PXUTheme.translation.contact_email;
  const notifySend = window.PXUTheme.translation.notify_form_send;
  const notifyUrl = $notifyFormInputs.data('url');
  let notifyMessage = '';
  let notifyEmailInput = '';
  if (variant) {
    if (variant.title != null) {
      // Escape variant titles
      const variantTitle = variant.title.toLowerCase() === 'default title' ? variant.name.replace(/"/g, '&quot;') : variant.title.replace(/"/g, '&quot;');
      notifyMessage = `${window.PXUTheme.translation.email_content}${variantTitle} | ${notifyUrl}?variant=${variant.id}`;
    }
  } else {
    notifyMessage = `${window.PXUTheme.translation.email_content} | ${notifyUrl}`;
  }
  if ($notifyFormInputs.hasClass('customer--true')) {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${window.PXUTheme.translation.customer_email}" />`;
  } else {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${notifyEmailValue}" />`;
  }
  const notifyFormHTML = `
    <input type="hidden" name="challenge" value="false" />
    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="${notifyMessage}" value="${notifyMessage}" />
    <div class="field has-addons">
      <div class="control">
        ${notifyEmailInput}
      </div>
      <div class="control">
        <input class="action_button button" type="submit" value="${notifySend}" />
      </div>
    </div>`;

  // Image Variant feature
  if (variant && variant.featured_image && $product.is(':visible')) {
    const $sliders = $('.product-gallery__main, .js-gallery-modal', $product);
    $sliders.each((_index, value) => {
      const $slider = $(value);
      const $sliderInstance = $slider.data('flickity');
      const index = $(`img[data-image-id=${variant.featured_media.id}]`).data('index');
      if ($slider.is(':visible') && $sliderInstance !== undefined) {
        $sliderInstance.select(index, false, true);
      }
    });
  }
  $('.cart-warning', $product).text('');
  if (variant) {
    $('.sku', $product).text(variant.sku);
    $('.notify_form_message', $product).attr('value', `${$('.notify_form_message', $product).data('body')} - ${variant.title}`);
  }
  if (variant && variant.available) {
    if (variant.inventory_management && variant.inventory_quantity > 0) {
      if (window.PXUTheme.theme_settings.display_inventory_left) {
        let itemsLeftText = window.PXUTheme.translation.product_count_other;
        if (variant.inventory_quantity === 1) {
          itemsLeftText = window.PXUTheme.translation.product_count_one;
        }
        const inventoryThreshold = window.PXUTheme.theme_settings.inventory_threshold;
        if (variant.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(`${variant.inventory_quantity} ${itemsLeftText}`);
        } else {
          $('.items_left', $product).html('');
        }
      }
      if (variant.inventory_policy === 'deny') {
        $('[data-max-inventory-management]', $product).attr('max', variant.inventory_quantity);

        // Check to see if quantity selector should be disabled based on inventory remaining
        window.PXUTheme.quantityBox.updateQuantityControls($productFormInput);
      }
    } else {
      $('.items_left', $product).text('');
      $('[data-max-inventory-management]', $product).removeAttr('max');
    }
    $('.sold_out', $product).text('');
    $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', null).find('span:not(.icon)').text($('[data-add-to-cart-trigger]', $product).data('label'));

    // Initialize shopify payment buttons
    if (Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
    $('.shopify-payment-button', $product).show();
    $('.purchase-details__quantity', $product).show();
    $notifyForm.hide();
    $notifyFormInputs.empty();
    $notifyFormInputs.append(notifyFormHTML);
    if (window.PXUTheme.currencyConverter) {
      window.PXUTheme.currencyConverter.convertCurrencies();
    }
  } else {
    // No purchasable variant. Three contexts:
    // - a variant is selected but sold out -> "Sold out"
    // - options are not fully selected yet (e.g. auto-select disabled) -> prompt to choose
    // - a complete selection maps to no available variant -> "Unavailable"
    const notSelected = !variant && state === 'not-selected';
    let message;
    if (variant) {
      message = window.PXUTheme.translation.soldOut;
    } else if (notSelected) {
      message = window.PXUTheme.translation.select_variant;
    } else {
      message = window.PXUTheme.translation.unavailable;
    }
    $('.items_left', $product).text('');
    $('[data-max-inventory-management]', $product).removeAttr('max');
    // Don't surface a sold-out style notice when the shopper simply hasn't chosen options yet.
    if (!notSelected) $('.sold_out', $product).text(message);
    $('[data-add-to-cart-trigger]', $product).addClass('disabled').attr('disabled', 'disabled').attr('data-options-unselected', notSelected ? 'true' : null).find('span:not(.icon)').text(message);
    $('.shopify-payment-button', $product).hide();
    $('.purchase-details__quantity', $product).hide();
    $notifyForm.hide();
    $notifyFormInputs.empty();
    if (variant && !variant.available) {
      $notifyForm.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }
}
window.selectCallback = selectCallback;

/* eslint-disable */
window.PXUTheme.predictiveSearch = {
  vars: {
    term: '',
    searchResourceType: null,
    mobileSearchPosition: 0,
    mobileSearchTrigger: null,
    visualViewportHandler: null
  },
  init: function () {
    const openMobileSearch = document.querySelector('.mobile-search--visible');
    const mobileSearchHadFocus = openMobileSearch &&
      openMobileSearch.contains(document.activeElement);
    this.unload(openMobileSearch);
    document.querySelectorAll('.search-form').forEach(form => {
      ['unavailable_products', 'prefix'].forEach(option => {
        const name = `options[${option}]`;
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = option === 'unavailable_products' ? 'show' : 'last';
      });
    });
    $('[data-show-search-trigger], [data-autocomplete-true] input')
      .off('click.predictiveSearch')
      .on('click.predictiveSearch', function (e) {
        if (!isScreenSizeLarge()) {
          // Keep the search-results page field editable in place.
          if (this.closest('.esl-search-page-form')) return;
          e.stopPropagation();
          if ($(this).is('[data-show-search-trigger]')) {
            e.preventDefault();
            window.PXUTheme.predictiveSearch.vars.mobileSearchTrigger = this;
          }
          const formType = $(this).closest('form').find('[name="type"]').val();
          window.PXUTheme.predictiveSearch.showMobileSearch(formType);
        }
      });
    $('.search-form .search__fields input[type="text"], .search-form .field input[type="text"]')
      .off('focus.predictiveSearch')
      .on('focus.predictiveSearch', e => {
      const dataSearchResourceType = e.target.closest('[data-search-resource-type]');
      if (dataSearchResourceType) {
        window.PXUTheme.predictiveSearch.vars.searchResourceType = dataSearchResourceType.getAttribute('data-search-resource-type');
      }

      // Set the cursor at the end of the input field for better UX,
      // otherwise it may be at the beginning of the input field when the input gets focus.
      const searchInputEl = e.target;
      const searchInputVal = searchInputEl.value.trim();
      searchInputEl.setSelectionRange(searchInputVal.length, searchInputVal.length);
      const searchFormEl = searchInputEl.closest('.search-form');
      if (searchFormEl && searchFormEl.suppressNextPredictiveFocus) {
        searchFormEl.suppressNextPredictiveFocus = false;
        return;
      }
      window.PXUTheme.predictiveSearch.getResults(searchInputVal, $(e.target.closest('.search-form')));
      });

    // Clicking outside makes the results disappear.
    $(document)
      .off('click.predictiveSearch focusout.predictiveSearch')
      .on('click.predictiveSearch focusout.predictiveSearch', function (e) {
      if (window.PXUTheme.media_queries.large.matches) {
        const searchTarget = e.type === 'focusout' ? e.relatedTarget : e.target;
        const searchForm = $(searchTarget).closest('.search-form');
        // Moving between the dialog's Close button and results stays inside search.
        const staysInOverlay = e.type === 'focusout' &&
          $(searchTarget).closest('[data-search-type="overlay"].is-opened').length > 0;
        if (searchForm.length === 0 && !staysInOverlay) {
          $('[data-autocomplete-true] .search__results-wrapper').hide();

          // This is for when the 'Vertical' header layout or the 'Search focus' header layout is in use,
          // since unlockBodyScroll won't get called in jsHeader.
          if ((window.PXUTheme.theme_settings.header_layout === 'vertical' || window.PXUTheme.theme_settings.header_layout === 'search_focus') && document.documentElement.classList.contains('scroll-locked')) {
            window.PXUTheme.predictiveSearch.unlockBodyScroll();
          }
        }
      }
      });
    $("[data-autocomplete-true] form")
      .off('submit.predictiveSearch')
      .on('submit.predictiveSearch', function (e) {
      const query = $(this).find('input[name="q"]').val().trim();
      if (!query) e.preventDefault();
      });
    $('[data-autocomplete-true] form').each(function (index) {
      const predictiveSearch = window.PXUTheme.predictiveSearch;
      const $this = $(this);
      const input = $this.find('input[name="q"]');
      let $resultsWrapper = $this.children('.search__results-wrapper').first();

      if ($resultsWrapper.length === 0) {
        $resultsWrapper = $('<div class="search__results-wrapper"></div>').appendTo($this);
      }

      if (!input.attr('id')) {
        input.attr('id', `predictive-search-input-${index + 1}`);
      }

      const resultsId = `${input.attr('id')}-results`;
      let $status = $this.children('[data-search-status]').first();
      if ($status.length === 0) {
        $status = $('<p class="visually-hidden" aria-live="polite" aria-atomic="true" data-search-status></p>').appendTo($this);
      }
      if (!$status.attr('id')) {
        $status.attr('id', `${input.attr('id')}-status`);
      }
      $resultsWrapper.attr({
        id: resultsId,
        role: 'region',
        'aria-label': 'Search suggestions and products',
        'aria-busy': 'false'
      });
      input.attr({
        autocomplete: 'off',
        'aria-controls': resultsId,
        'aria-describedby': $status.attr('id')
      });

      input
        .off('input.predictiveSearch input.predictiveSearchFetch keydown.predictiveSearch')
        .on('input.predictiveSearch', () => {
          predictiveSearch.vars.term = this.querySelector('[data-q]').value.trim();
          predictiveSearch.abortRequest($this);
          predictiveSearch.updateClearButton($this);
          if (!predictiveSearch.vars.term) {
            predictiveSearch.clearResults($this);
          }
        })
        .on('input.predictiveSearchFetch', () => {
          window.clearTimeout(this.predictiveSearchDebounceTimer);
          this.predictiveSearchDebounceTimer = window.setTimeout(() => {
            this.predictiveSearchDebounceTimer = null;
            predictiveSearch.vars.term = this.querySelector('[data-q]').value.trim();
            predictiveSearch.getResults(predictiveSearch.vars.term, $this);
          }, 160);
        })
        .on('keydown.predictiveSearch', e => predictiveSearch.handleSearchKeyDown(e, $this));

      $resultsWrapper
        .off('keydown.predictiveSearch')
        .on('keydown.predictiveSearch', 'a, button', function (e) {
          predictiveSearch.handleResultKeyDown(e, $this, this);
        });

      $this
        .off('click.predictiveSearchSuggestion', '[data-search-suggestion]')
        .on('click.predictiveSearchSuggestion', '[data-search-suggestion]', function (e) {
          e.preventDefault();
          const searchTerm = this.getAttribute('data-search-suggestion');
          predictiveSearch.abortRequest($this);
          input.val(searchTerm).trigger('input');
          predictiveSearch.vars.term = searchTerm;
          predictiveSearch.updateClearButton($this);
          predictiveSearch.focusSearchInput($this, true);
        })
        .off('click.predictiveSearchClear', '[data-search-clear]')
        .on('click.predictiveSearchClear', '[data-search-clear]', function (e) {
          e.preventDefault();
          predictiveSearch.abortRequest($this);
          input.val('');
          predictiveSearch.vars.term = '';
          predictiveSearch.updateClearButton($this);
          predictiveSearch.clearResults($this);
          predictiveSearch.focusSearchInput($this, true);
        });

      predictiveSearch.updateClearButton($this);
      const initialTerm = input.val().trim();
      const preserveFocusedResults = openMobileSearch &&
        $resultsWrapper[0] &&
        $resultsWrapper[0].contains(document.activeElement);
      const activeSearchForm = (
        $this.closest('.mobile-search--visible').length > 0 ||
        input[0] === document.activeElement
      );
      const restoreActiveSearch = initialTerm && activeSearchForm;
      if (preserveFocusedResults) {
        $resultsWrapper.attr('aria-busy', 'false');
      } else if (restoreActiveSearch) {
        predictiveSearch.vars.term = initialTerm;
        predictiveSearch.getResults(initialTerm, $this);
      } else if (activeSearchForm) {
        predictiveSearch.clearResults($this);
      } else {
        $resultsWrapper.empty().hide().attr('aria-busy', 'false');
        $status.text('');
      }
    });
    $(window)
      .off('resize.predictiveSearch')
      .on('resize.predictiveSearch', window.PXUTheme.debounce(() => {
        if (window.PXUTheme.theme_settings.header_layout === 'vertical') {
          window.PXUTheme.predictiveSearch.alignVerticalSearch();
        }
        const mobileSearchFields = document.querySelector(
          '.mobile-search--visible .search__fields'
        );
        const visibleMobileSearch = document.querySelector('.mobile-search--visible');
        if (visibleMobileSearch) {
          this.positionMobileSearch(visibleMobileSearch);
        }
        this.resizeSearchResults(mobileSearchFields || undefined);
      }, 150));

    if (window.visualViewport) {
      this.vars.visualViewportHandler = window.PXUTheme.debounce(() => {
        const visibleMobileSearch = document.querySelector('.mobile-search--visible');
        const mobileSearchFields = document.querySelector(
          '.mobile-search--visible .search__fields'
        );

        if (visibleMobileSearch) {
          this.positionMobileSearch(visibleMobileSearch);
        }
        if (mobileSearchFields) {
          this.resizeSearchResults(mobileSearchFields);
        }
      }, 50);
      window.visualViewport.addEventListener(
        'resize',
        this.vars.visualViewportHandler
      );
      window.visualViewport.addEventListener(
        'scroll',
        this.vars.visualViewportHandler
      );
    }
    $(document)
      .off('keyup.predictiveSearch')
      .on('keyup.predictiveSearch', e => this.onKeyUp(e));
    if (openMobileSearch && openMobileSearch.isConnected) {
      this.bindMobileSearchInteractions(
        $(openMobileSearch),
        this.vars.mobileSearchPosition
      );
      if (mobileSearchHadFocus && !openMobileSearch.contains(document.activeElement)) {
        this.focusSearchInput($(openMobileSearch).find('form').first(), true);
      }
    }
  },
  updateClearButton: function ($form) {
    const hasQuery = $form.find('input[data-q]').val().trim().length > 0;
    $form.find('[data-search-clear]').each(function () {
      this.hidden = !hasQuery;
    });
  },
  focusSearchInput: function ($form, suppressRequest) {
    const formEl = $form && $form[0];
    const inputEl = $form && $form.find('input[data-q]')[0];
    if (!inputEl) {
      return;
    }

    const shouldSuppressFocusRequest = suppressRequest &&
      formEl &&
      document.activeElement !== inputEl;

    if (shouldSuppressFocusRequest) {
      formEl.suppressNextPredictiveFocus = true;
    }

    try {
      inputEl.focus({
        preventScroll: true
      });
    } catch (error) {
      inputEl.focus();
    }

    // focus events are synchronous. Clear the flag if focus did not consume it,
    // otherwise a later reopen can accidentally suppress discovery results.
    if (shouldSuppressFocusRequest && formEl.suppressNextPredictiveFocus) {
      formEl.suppressNextPredictiveFocus = false;
    }
  },
  abortRequest: function ($form) {
    if (!$form || !$form.length) {
      return;
    }

    $form.each(function () {
      window.clearTimeout(this.predictiveSearchDebounceTimer);
      this.predictiveSearchDebounceTimer = null;
      window.clearTimeout(this.predictiveSearchTimeout);
      this.predictiveSearchTimeout = null;
      if (this.predictiveSearchController) {
        this.predictiveSearchController.abort();
        this.predictiveSearchController = null;
      }
      this.predictiveSearchRequestId = (this.predictiveSearchRequestId || 0) + 1;
      $(this).children('.search__results-wrapper').attr('aria-busy', 'false');
    });
  },
  showRequestState: function ($form, state) {
    const template = $form.find('template[data-search-state="' + state + '"]')[0];
    const $wrapper = $form.children('.search__results-wrapper').first();
    if (!template || !template.content || !$wrapper.length) return;
    $wrapper.empty().show().attr('aria-busy', state === 'loading' ? 'true' : 'false');
    $wrapper[0].appendChild(template.content.cloneNode(true));
    $wrapper[0].scrollTop = 0;
    $form.children('[data-search-status]').text($wrapper.find('[data-search-message]').text());
    window.PXUTheme.predictiveSearch.resizeSearchResults($form.find('.search__fields')[0]);
  },
  showDiscovery: function ($form) {
    const template = $form.find('template.search__discovery-template')[0];
    const $resultsWrapper = $form.children('.search__results-wrapper').first();

    if (!$resultsWrapper.length) {
      return;
    }

    $resultsWrapper.empty().attr('aria-busy', 'false');

    if (template && template.content) {
      $resultsWrapper[0].appendChild(template.content.cloneNode(true));
      $resultsWrapper[0].scrollTop = 0;
      $resultsWrapper.show();
      $form.children('[data-search-status]').text('Popular searches, categories and brands are available.');
      const fields = $form.find('.search__fields')[0];
      if (fields) {
        this.resizeSearchResults(fields);
      }
    } else {
      $resultsWrapper.hide();
      $form.children('[data-search-status]').text('');
    }
  },
  getResultFocusables: function ($form) {
    return $form
      .children('.search__results-wrapper')
      .find('a:visible, button:visible')
      .toArray();
  },
  handleSearchKeyDown: function (e, $form) {
    if (e.key !== 'ArrowDown') {
      return;
    }

    const focusables = this.getResultFocusables($form);
    if (focusables.length) {
      e.preventDefault();
      focusables[0].focus();
    }
  },
  handleResultKeyDown: function (e, $form, currentTarget) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') {
      return;
    }

    const focusables = this.getResultFocusables($form);
    const currentIndex = focusables.indexOf(currentTarget);
    if (currentIndex === -1) {
      return;
    }

    e.preventDefault();
    const nextIndex = e.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
    if (nextIndex < 0) {
      this.focusSearchInput($form, true);
    } else if (nextIndex < focusables.length) {
      focusables[nextIndex].focus();
    } else if (focusables.length) {
      focusables[0].focus();
    }
  },
  onKeyUp: function (e) {
    if (e.code === 'Escape') {
      $('[data-q]').val('');
      window.PXUTheme.predictiveSearch.vars.term = '';

      if ($('.mobile-search').is('.mobile-search--visible')) {
        window.PXUTheme.predictiveSearch.hideMobileSearch();
        $('[data-autocomplete-true] .search__results-wrapper').hide();
        return;
      }

      window.PXUTheme.jsHeader.hideSearch();
    }
  },
  resizeSearchResults: function () {
    let inputFieldEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelector('[data-autocomplete-true]');

    if (!inputFieldEl) {
      return;
    }

    const viewportBottom = window.visualViewport
      ? window.visualViewport.offsetTop + window.visualViewport.height
      : window.innerHeight;
    const inputFieldElBottom = inputFieldEl.getBoundingClientRect().bottom;
    const offset = isScreenSizeLarge() ? 30 : 10;
    const resultsMaxHeight = `${Math.max(
      0,
      viewportBottom - inputFieldElBottom - offset
    )}px`;
    const autocompleteEl = inputFieldEl.closest('[data-autocomplete-true]');
    const resultsContainerEl = autocompleteEl
      ? autocompleteEl.querySelector('.search__results-wrapper')
      : null;

    if (!resultsContainerEl) {
      return;
    }

    resultsContainerEl.style.setProperty('--results-max-height', resultsMaxHeight);
  },
  getResults: function (term, $this) {
    const {
      header_layout
    } = window.PXUTheme.theme_settings;
    if (term.length === 0) {
      window.PXUTheme.predictiveSearch.abortRequest($this);
      if (header_layout === 'vertical' || header_layout === 'search_focus') {
        window.PXUTheme.predictiveSearch.unlockBodyScroll();
      }
      window.PXUTheme.predictiveSearch.clearResults($this);
      return;
    }
    const formEl = $this[0];
    const searchResourceType = formEl.getAttribute('data-search-resource-type') ||
      (formEl.querySelector('[name="type"]') || {}).value;
    const restrictResourceCondition = Boolean(searchResourceType);
    window.PXUTheme.predictiveSearch.abortRequest($this);
    $this.children('[data-search-status]').text('');
    const requestId = (formEl.predictiveSearchRequestId || 0) + 1;
    formEl.predictiveSearchRequestId = requestId;
    const requestController = window.AbortController ? new AbortController() : null;
    formEl.predictiveSearchController = requestController;
    window.PXUTheme.predictiveSearch.showRequestState($this, 'loading');
    $this.children('.search__results-wrapper').attr('aria-busy', 'true');
    if (formEl.closest('.mobile-search')) {
      formEl.predictiveSearchTimeout = window.setTimeout(() => {
        if (formEl.predictiveSearchRequestId !== requestId) return;
        window.PXUTheme.predictiveSearch.abortRequest($this);
        window.PXUTheme.predictiveSearch.showRequestState($this, 'error');
      }, 8000);
    }

    // Keep relevant sold-out products discoverable; the results template labels their stock status.
    fetch(`${window.PXUTheme.routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=predictive-search&resources[options][unavailable_products]=show${restrictResourceCondition ? `&resources[type]=${encodeURIComponent(searchResourceType)}` : ''}`, requestController ? {
      signal: requestController.signal
    } : undefined).then(response => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.text();
    }).then(text => {
      const mobileSearch = formEl.closest('.mobile-search');
      if (
        formEl.predictiveSearchRequestId !== requestId ||
        !formEl.isConnected ||
        $this.find('input[data-q]').val().trim() !== term ||
        (mobileSearch && !mobileSearch.classList.contains('mobile-search--visible'))
      ) {
        return;
      }

      if (!text.includes('id="shopify-section-predictive-search"')) {
        throw new Error('Invalid predictive search response');
      }
      window.PXUTheme.predictiveSearch.displayResults(text, $this);

      // This is for when the 'Vertical' header layout or the 'Search focus' header layout is in use,
      // since lockBodyScroll won't get called in jsHeader (due to the search icon trigger not being present).
      // lockBodyScroll has to be called here so the overlay appears at about the same time as the results.
      if ((header_layout === 'vertical' || header_layout === 'search_focus') && $this.closest('.jsHeader').length > 0) {
        window.PXUTheme.predictiveSearch.lockBodyScroll();
      }
    }).catch(error => {
      if (error.name === 'AbortError' || formEl.predictiveSearchRequestId !== requestId) {
        return;
      }
      window.PXUTheme.predictiveSearch.showRequestState($this, 'error');
    }).finally(() => {
      if (formEl.predictiveSearchRequestId === requestId) {
        window.clearTimeout(formEl.predictiveSearchTimeout);
        formEl.predictiveSearchTimeout = null;
        formEl.predictiveSearchController = null;
        $this.children('.search__results-wrapper').attr('aria-busy', 'false');
      }
    });
  },
  displayResults: function (results, $this) {
    const $fields = $this.find('.search__fields');
    const $resultsWrapper = $this.find('.search__results-wrapper');
    $resultsWrapper.show();
    $resultsWrapper.empty();
    $resultsWrapper.append(results);
    const resourceType = $this[0].getAttribute('data-search-resource-type') ||
      ($this[0].querySelector('[name="type"]') || {}).value;
    $resultsWrapper[0].querySelectorAll('a.all-results, a.search__results__item__suggestions').forEach(link => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('options[unavailable_products]', 'show');
      url.searchParams.set('options[prefix]', 'last');
      if (resourceType) url.searchParams.set('type', resourceType);
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
    $resultsWrapper[0].scrollTop = 0;
    $resultsWrapper.attr('aria-busy', 'false');
    const statusText = $resultsWrapper.find('[data-search-results-summary]').text().trim();
    $this.children('[data-search-status]').text(statusText);
    const inputFieldEls = $fields.length > 0 ? Array.from($fields) : document.querySelectorAll('[data-autocomplete-true]');

    // Calculate resultsWrapper max height for header search (exclude blog sidebar)
    inputFieldEls.forEach(el => {
      if (el.closest('.search-popup__form') || el.closest('.mobile-search')) {
        this.resizeSearchResults(el);
      }
    });
    if ($this.parents('.vertical-header__content').length && window.PXUTheme.jsHeader.header_layout === 'vertical') {
      window.PXUTheme.predictiveSearch.alignVerticalSearch();
    }
  },
  clearResults: function ($form) {
    const formEls = $form && $form.length
      ? $form.toArray()
      : Array.from(document.querySelectorAll('.search-form'));

    formEls.forEach(formEl => {
      this.showDiscovery($(formEl));
    });
  },
  positionMobileSearch: function (mobileSearch) {
    if (!mobileSearch) {
      return;
    }

    const pagePosition = window.PXUTheme.predictiveSearch.vars.mobileSearchPosition || 0;
    const visualOffsetTop = window.visualViewport
      ? Math.max(0, window.visualViewport.offsetTop || 0)
      : 0;
    const visualHeight = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;

    mobileSearch.style.top = `${pagePosition + visualOffsetTop}px`;
    mobileSearch.style.height = `${visualHeight}px`;
  },
  bindMobileSearchInteractions: function ($mobileSearch, position) {
    if (!$mobileSearch || !$mobileSearch.length) {
      return;
    }

    $mobileSearch
      .find('.close-search')
      .off('.mobileSearch')
      .on('click.mobileSearch', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.PXUTheme.predictiveSearch.hideMobileSearch(position);
        $('[data-autocomplete-true] .search__results-wrapper').hide();
      });
    $mobileSearch
      .off('keydown.mobileSearchTrap')
      .on('keydown.mobileSearchTrap', function (e) {
        if (e.key !== 'Tab') {
          return;
        }

        const focusables = $mobileSearch
          .find('input:visible, button:visible, a:visible')
          .filter(':not([disabled])')
          .toArray();
        if (!focusables.length) {
          return;
        }

        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    $(document)
      .off('click.mobileSearchOutside')
      .on('click.mobileSearchOutside', e => {
        if (!e.target.closest('.search-form') && $('.mobile-search').is('.mobile-search--visible')) {
          window.PXUTheme.predictiveSearch.hideMobileSearch();
        }
      });
  },
  showMobileSearch: function (formType) {
    let position = arguments.length > 1 && typeof arguments[1] === 'number'
      ? arguments[1]
      : window.pageYOffset || document.documentElement.scrollTop || 0;
    const mobileSearch = document.querySelector('.mobile-search');

    if (!mobileSearch) {
      return;
    }

    const mobileSearchInput = mobileSearch.querySelector('input[data-q]');
    const focusMobileSearchInput = function () {
      if (!mobileSearchInput) {
        return;
      }

      try {
        mobileSearchInput.focus({
          preventScroll: true
        });
      } catch (error) {
        mobileSearchInput.focus();
      }
    };

    if (mobileSearch.classList.contains('mobile-search--visible')) {
      focusMobileSearchInput();
      return;
    }

    const $mobileSearch = $(mobileSearch);
    $mobileSearch.stop(true, true).show();
    const $mobileSearchForm = $mobileSearch.find('form').first();

    window.PXUTheme.predictiveSearch.vars.mobileSearchPosition = position;
    this.positionMobileSearch(mobileSearch);
    if (window.PXUTheme.predictiveSearch.vars.mobileSearchTrigger) {
      window.PXUTheme.predictiveSearch.vars.mobileSearchTrigger.setAttribute('aria-expanded', 'true');
    }
    $('body').css('max-height', window.innerHeight);
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + position + 'px';
    $mobileSearch.addClass('mobile-search--visible');
    mobileSearch.setAttribute('aria-hidden', 'false');
    $mobileSearchForm.children('[data-search-status]').text('');

    // Keep focus synchronous with the tap so mobile browsers open the keyboard.
    focusMobileSearchInput();
    if (formType) {
      $('.mobile-search [name="type"]').val(formType);
    }
    this.updateClearButton($mobileSearchForm);
    this.bindMobileSearchInteractions($mobileSearch, position);
  },
  hideMobileSearch: function () {
    let position = arguments.length > 0 && typeof arguments[0] === 'number'
      ? arguments[0]
      : window.PXUTheme.predictiveSearch.vars.mobileSearchPosition || 0;
    const mobileSearchTrigger = window.PXUTheme.predictiveSearch.vars.mobileSearchTrigger;
    const mobileSearch = document.querySelector('.mobile-search');
    $('body').css('max-height', 'none');
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, position);
    $('.mobile-search').removeClass('mobile-search--visible');
    if (mobileSearch) {
      mobileSearch.setAttribute('aria-hidden', 'true');
      $(mobileSearch).off('keydown.mobileSearchTrap');
    }
    this.abortRequest($(mobileSearch).find('form').first());
    $('.mobile-search').stop(true, true).fadeOut(100);
    $('body').off('focus', '.search-form .close-search');
    $('body').off('focus', '.search-form .submit-search');
    $(document).off('click.mobileSearchOutside');
    window.PXUTheme.predictiveSearch.unlockBodyScroll();
    if (mobileSearchTrigger && document.documentElement.contains(mobileSearchTrigger)) {
      mobileSearchTrigger.setAttribute('aria-expanded', 'false');
      try {
        mobileSearchTrigger.focus({
          preventScroll: true
        });
      } catch (error) {
        mobileSearchTrigger.focus();
      }
    } else if (mobileSearch && mobileSearch.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  },
  lockBodyScroll: function () {
    document.documentElement.classList.add('scroll-locked');
    document.querySelector('[data-site-overlay]').classList.remove('site-overlay--hidden');
  },
  unlockBodyScroll: function () {
    document.documentElement.classList.remove('scroll-locked');
    document.querySelector('[data-site-overlay]').classList.add('site-overlay--hidden');
  },
  alignVerticalSearch: function () {
    const $resultsList = $('.header--vertical .search__results');
    const headerWidth = $('.header--vertical').innerWidth();
    $resultsList.parents('.search__results-wrapper').css({
      'position': 'fixed',
      'left': headerWidth,
      'top': '0'
    });
  },
  unload: function (openMobileSearch) {
    $(window).off('resize.predictiveSearch');
    $(document).off('.predictiveSearch');
    $('.search-form').off('.predictiveSearch .predictiveSearchSuggestion .predictiveSearchClear');
    $('[data-show-search-trigger], [data-autocomplete-true] input').off('click.predictiveSearch');
    $('.search-form .close-search').off('.mobileSearch');
    $('.mobile-search').off('keydown.mobileSearchTrap');
    $(document).off('click.mobileSearchOutside');
    this.abortRequest($('.search-form'));
    if (window.visualViewport && this.vars.visualViewportHandler) {
      window.visualViewport.removeEventListener(
        'resize',
        this.vars.visualViewportHandler
      );
      window.visualViewport.removeEventListener(
        'scroll',
        this.vars.visualViewportHandler
      );
      this.vars.visualViewportHandler = null;
    }
    $('body').off('focus', '[data-autocomplete-true] input');
    $('input[name="q"]').off('.predictiveSearch .predictiveSearchFetch');
    $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off('.predictiveSearch');
    $('.search__results-wrapper').filter(function () {
      return !openMobileSearch || !openMobileSearch.contains(this);
    }).remove();
  }
};
function isScreenSizeLarge() {
  if (window.PXUTheme.media_queries.large.matches) {
    return true;
  }
}
window.PXUTheme.scrollToTop = function (element, height) {
  // Check if height argument is present
  if (height != undefined) {
    $('html, body').animate({
      scrollTop: $(element).offset().top - height
    }, 1000);
  } else {
    $('html, body').animate({
      scrollTop: $(element).offset().top
    }, 1000);
  }
};
window.PXUTheme.tabs = {
  enableTabs: function () {
    let $tabs = $('.tabs li, .tabs li a');
    $tabs.on('click', function (el) {
      el.preventDefault();

      // toggle active tab
      $tabs.removeClass('is-active active');
      $(this).addClass('is-active');
      let $tabIndex = $(this).index();
      let $tabContent = $(this).parents('.tabs').next('.tabs-content');

      // toggle corresponding tab content
      $tabContent.children('li, li a').removeClass('is-active active');
      $tabContent.children('li, li a').eq($tabIndex).addClass('is-active').show().css({
        'display': 'block'
      }).siblings().hide().removeClass('is-active');
    });
  },
  unload: function () {
    $('.tabs li, .tabs li a').off();
  }
};
class ProductCard {
  swapCardImage(thumbnailEl, imageUrl) {
    if (!thumbnailEl || !imageUrl) return;
    const cardImage = thumbnailEl.querySelector('.product__imageContainer img:not(.secondary)');
    if (!cardImage) return;
    cardImage.setAttribute('src', imageUrl);
    cardImage.setAttribute('srcset', imageUrl);
  }
  enableSwatches() {
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.kit-swatch[data-image]', _ref => {
        let {
          currentTarget
        } = _ref;
        if ($(currentTarget).data('image') && $(currentTarget).data('image').indexOf('no-image') === -1) {
          window.PXUTheme.thumbnail.swapCardImage($(currentTarget).parents('.thumbnail')[0], $(currentTarget).data('image'));
        }
      });
    }
  }
  showVariantImage() {
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.has-secondary-image-swap', function () {
        const $primaryImage = $(this).find('.product-image__wrapper img:not(.secondary)');
        const $secondaryImage = $(this).find('.product-image__wrapper img.secondary');
        const $thumbnailVideo = $(this).find('.product-image__wrapper .video-on-hover');
        $primaryImage.addClass('swap--visible');
        $secondaryImage.removeClass('swap--visible');
        if ($thumbnailVideo) {
          $thumbnailVideo.toggleClass('swap--visible');
          window.PXUTheme.video.enableVideoOnHover($(this));
        }
      });
      $('body').on('mouseleave', '.has-secondary-image-swap', function () {
        const $primaryImage = $(this).find('.product-image__wrapper img:not(.secondary)');
        const $secondaryImage = $(this).find('.product-image__wrapper img.secondary');
        const $thumbnailVideo = $(this).find('.product-image__wrapper .video-on-hover');
        $primaryImage.removeClass('swap--visible');
        $secondaryImage.addClass('swap--visible');
        if ($thumbnailVideo) {
          $thumbnailVideo.toggleClass('swap--visible');
          window.PXUTheme.video.disableVideoOnHover($(this));
        }
      });
    }
  }
  showQuickShop() {
    // EVENT - click on quick-shop
    $('body').on('click', '.js-quick-shop-link', e => {
      e.preventDefault();
      const $currentTarget = $(e.currentTarget);
      window.PXUTheme.jsProductClass.load($currentTarget.data('url')).then(_ref2 => {
        let {
          html
        } = _ref2;
        $('.js-quick-shop').html(html.content);
        $('.js-quick-shop [data-section-data]').attr('data-section-id', 'quickshop');
        $('.js-quick-shop .js-product_section').addClass('quickshop');
        if (!$('.fancybox-active').length) {
          $.fancybox.open($('.js-quick-shop'), {
            baseClass: `quick-shop__lightbox product-${$currentTarget.data('id')}`,
            hash: false,
            infobar: false,
            toolbar: false,
            loop: true,
            smallBtn: true,
            touch: false,
            video: {
              autoStart: false
            },
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true
            },
            beforeShow: () => {
              // Enable tabs
              if (document.querySelectorAll('.tabs').length > 0) {
                window.PXUTheme.tabs.enableTabs();
              }
              // Enable accordions
              if (document.querySelectorAll('.accordion').length > 0) {
                window.PXUTheme.contentCreator.accordion.init();
              }
            },
            afterShow: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              const $quickshop = $(src).find('.quick-shop');
              window.PXUTheme.jsProduct.init($('.js-quick-shop'));
              $quickshop.addClass('quick-shop--loaded');
              $quickshop.addClass('content-loaded');
            },
            beforeClose: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              const $quickshop = $(src).find('.quick-shop');
              $quickshop.removeClass('quick-shop--loaded');
              $quickshop.removeClass('content-loaded');
            }
          });
        }
      }).catch(error => console.error(error));
    });
  }
}
window.PXUTheme.thumbnail = new ProductCard();
const videoEl = {
  playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
};
const videoControls = `${videoEl.playButtonIcon}<div class="plyr__controls"> ${videoEl.playButton} ${videoEl.progressInput} ${videoEl.muteButton} ${videoEl.volume} ${videoEl.fullscreen}</div>`;
let videoPlayers = [];
let videosInRecommendedProductsPlayer;
window.PXUTheme.video = {
  init: function () {
    this.setupVideoPlayer();
  },
  setupVideoPlayer: function () {
    const productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');
    let setupVideoPlayers = Plyr.setup(productVideos, {
      controls: videoControls,
      ratio: this.aspect_ratio,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });
    let videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, function (index, player) {
      player.loop = videoLooping;
      videoPlayers.push(player);
    });
    this.setupListeners();
  },
  setupListeners: function () {
    // Adds plyr video id to video wrapper
    $.each(videoPlayers, function (index, player) {
      const id = player.id;
      let $video;
      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      }

      // When a video is playing, pause any other instances
      player.on('play', function (event) {
        var instance = event.detail.plyr;
        $.each(videoPlayers, function (index, player) {
          var playerID = player.id || player.media.dataset.plyrVideoId;
          if (instance.id != playerID) {
            player.pause();
          }
        });
      });
    });
  },
  enableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;
    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }
    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(false);
          player.muted = true;
          player.play();
        }
      });
    }
  },
  disableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;
    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }
    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      });
    }
  }
};


